import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const ChangePasswordService = (payload: UpdatePasswordType) => {
  return HTTP_CLIENT.post(Endpoint.user.changePassword, payload);
};

const GetUserProfileService = () => {
  return HTTP_CLIENT.get(Endpoint.user.getProfile);
};

const AddCollaboratorService = (payload: any) => {
  return HTTP_CLIENT.post(Endpoint.user.addCollaborator, payload);
};

const SearchBuilderService = (email: string) => {
  return HTTP_CLIENT.get(Endpoint.user.searchBuilder, {
    params: { email },
  });
};

const SearchCollaboratorService = (email: string) => {
  return HTTP_CLIENT.get(Endpoint.user.searchCollaborator, {
    params: { email },
  });
};
const UpdateUserService = (payload: any) => {
  return HTTP_CLIENT.put(Endpoint.user.updateUser, payload);
};
const UserFeedbackService = (payload: any) => {
  return HTTP_CLIENT.post(Endpoint.user.userFeedback, payload);
};

const DeleteCollaboratorService = (collaborator_id: string) => {
  return HTTP_CLIENT.delete(
    Endpoint.user.deleteCollaborator.replace(
      ":collaborator_id",
      collaborator_id,
    ),
  );
};

const GetUserDashboardWaitingRevisionsService = () => {
  return HTTP_CLIENT.get(Endpoint.user.userDashboardWaitingRevisions);
};

export {
  ChangePasswordService,
  GetUserProfileService,
  AddCollaboratorService,
  SearchBuilderService,
  SearchCollaboratorService,
  UpdateUserService,
  UserFeedbackService,
  DeleteCollaboratorService,
  GetUserDashboardWaitingRevisionsService,
};
